import styled from 'styled-components';

export const StyledOverviewWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  position: relative;
`;

export const TabWrapper = styled.div`
  background: #f5f5f5;
  border-bottom: 1px solid #e5e5e5;
  margin: 8px 5px 0;
  display: flex;
`;

export const PageHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 16px;
`;
